<script>
export default {
  components: {}
};
</script>

<style scoped>

#auth-container {
  /* background-image: url('~@/assets/images/background/back.png');  */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  /* height: 1080px; */
}

@media all and (max-width: 400px) {
    #auth-container {
    } 
}

@media all and (min-width: 401px) {
    #auth-container {
}

}

  @media all and (min-width: 1390px) {
    #auth-container {
        zoom: 100%;
    } 
  }

    @media all and (max-width: 1390px) {
    #auth-container {
        zoom: 70%;
    } 

    }

  @media all and (max-width: 800px) {
    #auth-container {
        zoom: 50%;
    } 
  }

  @media screen and (max-width: 500px) {
  #auth-container {
        zoom: 100%;
    } 
  }


  .auth-image-overlay {
  background: #40725b80; /* #407072c9;*/ /* #024822bf; */  /* #035629bf;*/ /*#00944340; */ /* #00acc840;*/
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
    filter: blur(3px);

}

</style>

<template>
  <div id="auth-container" class="" style="" >
    <vue-snotify></vue-snotify>
        <slot />
  </div>
</template>
